import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../../../shared/lib/query-keys.ts";
import { getApiStatus } from "../api/api-status-api.ts";
import type { ApiStatusData } from "../types/index.ts";

export function useApiStatusQuery(enabled: boolean) {
  return useQuery<ApiStatusData | null>({
    queryKey: queryKeys.apiStatus.summary(),
    queryFn: () => getApiStatus(),
    enabled,
    gcTime: 0,
  });
}
